(ns rothko.alert.component
  (:require [rothko.icon.component :as icon]))

(defn- alert-icon
  [type]
  (case type
    :error :warning
    :warning))

(defn message
  [{:keys [on-close]
    :or {on-close (constantly :noop)}

    {:keys [id dismissable? message on-click type]
     :or {dismissable? true
          on-click (constantly :noop)}} :alert

    :as props}]
  [:div.alert-message
   {:class #{type (when on-click :clickable)}}
   [:div {:class [:alert-content (when dismissable? :dismissable)]
          :on-click on-click}
    [icon/icon {:icon (alert-icon type)
                :class :alert-icon}]
    [:p message]]
   (when dismissable?
     [:div {:on-click #(on-close id)
            :class #{:alert-close-button}}
      [icon/icon {:icon :cross
                  }]])])

(defn banner
  [{:keys [banner-id on-close alerts max-alerts]
    :or {max-alerts 3}
    :as props}]
  (when (seq alerts)
    [:div.alert-banner
     (for [alert (take max-alerts alerts)]
       ^{:key alert}
       [message {:banner-id banner-id
                 :alert alert
                 :on-close on-close}])]))
